/**
 * Extracts the initials from a given title string.
 *
 * This function splits the input title into words, filters out words that are
 * shorter than 3 characters or equal to "null" (case insensitive), and then
 * takes the first character of the first two remaining words to form the initials.
 *
 * @param title - The input string from which to extract initials.
 * @returns A string containing the initials of the first two valid words, or an empty string if no valid words are found.
 */
export const getInitials = (title: string): string => {
  const words = title
    .split(" ")
    .filter((word) => word.length >= 1 && word.toLowerCase() !== "null");
  if (words.length === 0) return "";

  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
  return initials;
};
